export const EVENT_TRIGGERS = 'automationEventTriggers';